import { NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { LoginComponent } from './components/user/login/login.component';

import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { HomeComponent } from './components/user/home/home.component';
import { HomeComponent as Layout } from './components/home/home.component';
import { HasRoleDirective } from './directives/has-role.directive';
import { CircleHttpInterceptor } from './app.interceptor';
import { RegisterComponent } from './components/user/register/register.component';
import { PageNotFoundComponent } from './components/common/page-not-found/page-not-found.component';
import { SharedModule } from './shared/shared.module';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { UserLinksComponent } from './components/common/user-links/user-links.component';
import { ManageCourseComponent } from './components/course/manage-course/manage-course.component';
import { CourseDetailComponent } from './components/course/course-detail/course-detail.component';
import { ForgotPasswordComponent } from './components/user/forgot-password/forgot-password.component';
import { ResetPasswordComponent } from './components/user/reset-password/reset-password.component';
import { PreventDefaultDirective } from './directives/prevent-default.directive';

@NgModule({
  declarations: [
    AppComponent,
    CourseDetailComponent,
    HasRoleDirective,
    HomeComponent,
    Layout,
    LoginComponent,
    ManageCourseComponent,
    PageNotFoundComponent,
    RegisterComponent,
    UserLinksComponent,
    ForgotPasswordComponent,
    ResetPasswordComponent,
    PreventDefaultDirective,
  ],
  imports: [
    AppRoutingModule,
    BrowserModule,
    BrowserAnimationsModule,
    SharedModule,
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: CircleHttpInterceptor,
      multi: true, // This is important to allow multiple interceptors
    },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
